import c from 'classnames';
import React from 'react';
import CountUp from 'react-countup';

import { Typography } from '@repo/ui';
import MicrobiomeScoreChart from 'components/MicrobiomeScoreChart/MicrobiomeScoreChart';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import useMssData from 'services/mss/useMssData';
import { getPopScoreInfo } from '../../SummaryCards/MicrobiomeScoreSummaryCard/MicrobiomeScoreSummaryCard';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import { getAgeGroup, getMicrobiomeScoreMessage } from '@repo/utils';
import styles from './Mss.module.css';
import slideStyles from './Slides.module.css';

export const Mss: React.FC = () => {
  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const { popGutScore, mssData: chartData } = useMssData(currentKit?.id);

  const { color } = getPopScoreInfo(
    currentKit,
    currentTinyAccount,
    popGutScore,
    chartData,
  );

  if (!currentKit || !popGutScore || !currentTinyAccount) return <></>;

  const isAdult = getAgeGroup(currentKit.age_at_sampling ?? 0) === 'adult';
  const name = currentTinyAccount.first_name;
  const { mainText } = getMicrobiomeScoreMessage({ color, isAdult, name });

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.mss }}
    >
      <div className={styles.top}>
        <Typography variant='heading-m'>
          {isAdult ? 'Your' : `${name}'s`} Microbiome Score
        </Typography>
        <div>
          <Typography variant='display-l'>
            <CountUp end={Math.round(popGutScore)} duration={1.5} />
          </Typography>
          <Typography variant='body-m'> /100</Typography>
        </div>
        {mainText && <Typography variant='body-s'>{mainText}</Typography>}
      </div>
      <div className={styles.bottom}>
        <MicrobiomeScoreChart
          kit={currentKit}
          popScore={popGutScore}
          minimal
          customHeight={'100%'}
          customWidth={'98%'}
          animateMarker
        />
      </div>
    </div>
  );
};
